import { defineComponent } from "vue";
import Title from "../components/TheTitle.vue";
import { importCsv } from "../api";
import { Authorize } from "../utils/authorize";
export default defineComponent({
    name: "csvImport",
    components: {
        Title,
    },
    data() {
        return {
            selectedFile: null,
            filename: "",
            errorMessage: "",
            loading: false,
            matched: [],
            unmatched: [],
            pageSize: 100,
            matchedPage: 1,
            unmatchedPage: 1,
        };
    },
    computed: {
        matchedTotalPages() {
            return Math.max(1, Math.ceil(this.matched.length / this.pageSize));
        },
        unmatchedTotalPages() {
            return Math.max(1, Math.ceil(this.unmatched.length / this.pageSize));
        },
        pagedMatched() {
            const start = (this.matchedPage - 1) * this.pageSize;
            return this.matched.slice(start, start + this.pageSize);
        },
        pagedUnmatched() {
            const start = (this.unmatchedPage - 1) * this.pageSize;
            return this.unmatched.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        matched() {
            this.matchedPage = 1;
        },
        unmatched() {
            this.unmatchedPage = 1;
        },
    },
    methods: {
        setMatchedPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.matchedTotalPages)
                p = this.matchedTotalPages;
            this.matchedPage = p;
        },
        setUnmatchedPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.unmatchedTotalPages)
                p = this.unmatchedTotalPages;
            this.unmatchedPage = p;
        },
        // ファイル選択時（MIME と拡張子チェック）
        onFileChange(e) {
            const target = e.target;
            const f = target.files?.[0] ?? null;
            // クリア
            this.selectedFile = null;
            this.filename = "";
            this.errorMessage = "";
            this.matched = [];
            this.unmatched = [];
            this.loading = false;
            if (!f)
                return;
            // MIME と拡張子チェック（ブラウザ依存のため両方確認）
            const mime = (f.type || "").toLowerCase();
            const name = (f.name || "").toLowerCase();
            const extIsCsv = name.endsWith(".csv");
            const mimeOk = mime.includes("csv") ||
                mime === "text/plain" ||
                mime === "application/vnd.ms-excel";
            if (!mimeOk && !extIsCsv) {
                this.errorMessage = "CSVファイル（.csv）を選択してください。";
                return;
            }
            this.selectedFile = f;
            this.filename = f.name;
            // 選択したら自動でアップロード（必要な場合のみ）
            this.uploadFile();
        },
        // ファイルを FormData で送信
        async uploadFile() {
            if (!this.selectedFile) {
                this.errorMessage = "ファイルが選択されていません。";
                return;
            }
            this.errorMessage = "";
            this.matched = [];
            this.unmatched = [];
            this.loading = true;
            let rspBody;
            try {
                rspBody = await importCsv(this.selectedFile);
                if (rspBody.result.code === 9) {
                    if (rspBody.result.messages) {
                        this.$store.commit("setMessages", rspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                }
                else {
                    const data = rspBody.data;
                    this.matched = data.results ?? [];
                    this.unmatched = data.non_existing_crm_customer_id_list ?? [];
                }
            }
            catch (err) {
                this.errorMessage =
                    err?.message ?? "アップロード中にエラーが発生しました。";
            }
            finally {
                this.loading = false;
            }
        },
        onBack() {
            window.history.back();
        },
        goNext() {
            this.$store.commit("setCsvMatched", this.matched);
            this.$router.back();
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
});
